export const ISO693_TO_3 = {
  aa: 'aar',
  ab: 'abk',
  ae: 'ave',
  af: 'afr',
  ak: 'aka',
  am: 'amh',
  an: 'arg',
  ar: 'aao',
  as: 'asm',
  av: 'ava',
  ay: 'aym',
  az: 'azb',
  ba: 'bak',
  be: 'bel',
  bg: 'bul',
  bi: 'bis',
  bm: 'bam',
  bn: 'ben',
  bo: 'bod',
  br: 'bre',
  ca: 'cat',
  ce: 'che',
  ch: 'cha',
  co: 'cos',
  cr: 'cre',
  cs: 'ces',
  cu: 'chu',
  cv: 'chv',
  cy: 'cym',
  da: 'dan',
  de: 'deu',
  dv: 'div',
  dz: 'dzo',
  ee: 'ewe',
  el: 'ell',
  en: 'eng',
  eo: 'epo',
  es: 'spa',
  et: 'ekk',
  eu: 'eus',
  fa: 'fas',
  ff: 'ffm',
  fi: 'fin',
  fj: 'fij',
  fo: 'fao',
  fr: 'fra',
  fy: 'fry',
  ga: 'gle',
  gd: 'gla',
  gl: 'glg',
  gn: 'gnw',
  gu: 'guj',
  gv: 'glv',
  ha: 'hau',
  he: 'heb',
  hi: 'hin',
  ho: 'hmo',
  ht: 'hat',
  hu: 'hun',
  hy: 'hye',
  hz: 'her',
  ia: 'ina',
  ie: 'ile',
  ig: 'ibo',
  ii: 'iii',
  ik: 'esi',
  io: 'ido',
  is: 'isl',
  it: 'ita',
  iu: 'ike',
  ja: 'jpn',
  jv: 'jav',
  ka: 'kat',
  kg: 'kng',
  ki: 'kik',
  kj: 'kua',
  kk: 'kaz',
  kl: 'kal',
  km: 'khm',
  kn: 'kan',
  ko: 'kor',
  kr: 'kau',
  ks: 'kas',
  ku: 'ckb',
  kv: 'koi',
  kw: 'cor',
  ky: 'kir',
  la: 'lat',
  lb: 'ltz',
  lg: 'lug',
  li: 'lim',
  ln: 'lin',
  lo: 'lao',
  lt: 'lit',
  lu: 'lub',
  lv: 'lav',
  mg: 'bhr',
  mh: 'mah',
  mi: 'mri',
  mk: 'mkd',
  ml: 'mal',
  mn: 'khk',
  mr: 'mar',
  ms: 'bjn',
  mt: 'mlt',
  my: 'mya',
  na: 'nau',
  nd: 'nde',
  ne: 'dty',
  ng: 'ndo',
  nl: 'nld',
  no: 'nno',
  nr: 'nbl',
  nv: 'nav',
  ny: 'nya',
  oc: 'oci',
  oj: 'ojb',
  om: 'gax',
  or: 'ori',
  os: 'oss',
  pa: 'pan',
  pi: 'pli',
  pl: 'pol',
  ps: 'pbt',
  pt: 'por',
  qu: 'qub',
  rm: 'roh',
  rn: 'run',
  ro: 'ron',
  ru: 'rus',
  rw: 'kin',
  sa: 'san',
  sc: 'sdc',
  sd: 'snd',
  se: 'sme',
  sg: 'sag',
  sh: 'bos',
  si: 'sin',
  sk: 'slk',
  sl: 'slv',
  sm: 'smo',
  sn: 'sna',
  so: 'som',
  sq: 'aae',
  ss: 'ssw',
  st: 'sot',
  su: 'sun',
  sv: 'swe',
  sw: 'swa',
  ta: 'tam',
  te: 'tel',
  tg: 'tgk',
  th: 'tha',
  ti: 'tir',
  tk: 'tuk',
  tl: 'tgl',
  tn: 'tsn',
  to: 'ton',
  tr: 'tur',
  ts: 'tso',
  tt: 'tat',
  ty: 'tah',
  ug: 'uig',
  uk: 'ukr',
  ur: 'urd',
  uz: 'uzb',
  ve: 'ven',
  vi: 'vie',
  vo: 'vol',
  wa: 'wln',
  wo: 'wol',
  xh: 'xho',
  yi: 'ydd',
  yo: 'yor',
  za: 'zch',
  zh: 'cdo',
  zu: 'zul',
};
